import { createEvent } from 'effector';

export type AlertType = 'info' | 'success' | 'error' | 'warning' | null;

export type ShowAlertPayload = {
  css?: string | null;
  duration?: number;
  label: string | React.ReactElement;
  onClick?: () => void;
  type?: AlertType;
};

export type ShowBottomAlertPayload = {
  customAlert?: React.ReactElement | null;
  label?: string | React.ReactElement;
  position?: number | null;
  type?: AlertType;
};

/**
 * @deprecated Use `toaster.create` from `@m/components/ui/toaster` instead.
 */
export const showAlert = createEvent<ShowAlertPayload>();

/**
 * @deprecated Use `toaster.dismiss` from `@m/components/ui/toaster` instead.
 */
export const hideAlert = createEvent<void>();

/**
 * @deprecated Use `toaster.create` from `@m/components/ui/toaster` instead.
 */
export const showBottomAlert = createEvent<ShowBottomAlertPayload>();

/**
 * @deprecated Use `toaster.dismiss` from `@m/components/ui/toaster` instead.
 */
export const hideBottomAlert = createEvent<void>();
